import './dettaglio-articolo.scss';

/**
 * version    1.0
 * class      <type> (DettaglioArticolo)
 * classdesc
 */
export class DettaglioArticolo {}
